import Footer from "../../component/Footer";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import AgentNavbar from "../../component/AgentNavbar";
import { ChevronRight, User, LogOut, Key } from "react-feather";
import { baseurl } from "../../component/Baseurl";
import Swal from 'sweetalert2'; // Import SweetAlert2

function AgentAccount() {
  const [agentDetails, setAgentDetails] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    city: '',
    state: '',
    country: '',
    pincode: ''
  });

  // Fetch agent details
  useEffect(() => {
    const agentid = localStorage.getItem("agent_id");

    // Fetching agent data
    fetch(`${baseurl}getAgentById/${agentid}`)
      .then((response) => response.json())
      .then((data) => {
        if (data && data.agent) {
          setAgentDetails(data.agent);
          // Populate form fields with fetched data
          setFormData({
            name: data.agent.name,  // Use name directly
            email: data.agent.email,
            phone: data.agent.phone,
            city: data.agent.city,
            state: data.agent.state,
            country: data.agent.country,
            pincode: data.agent.pincode
          });
        }
      })
      .catch((error) => console.error('Error fetching agent data:', error));
  }, []);

  // Handle form changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  // Update agent details
  const handleSubmit = (e) => {
    e.preventDefault();
    const agentid = localStorage.getItem("agent_id");

    const updatedData = {
      name: formData.name,  // Only use the name
      email: formData.email,
      phone: formData.phone,
      city: formData.city,
      state: formData.state,
      country: formData.country,
      pincode: formData.pincode
    };

    fetch(`${baseurl}updateAgentById/${agentid}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(updatedData)
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message === "Agent updated successfully") {
          // Show SweetAlert2 success message
          Swal.fire({
            title: 'Success!',
            text: 'Agent details updated successfully!',
            icon: 'success',
            confirmButtonText: 'OK'
          });
        }
      })
      .catch((error) => {
        console.error('Error updating agent details:', error);
        // Optionally show an error message with SweetAlert2
        Swal.fire({
          title: 'Error!',
          text: 'Failed to update agent details.',
          icon: 'error',
          confirmButtonText: 'Try Again'
        });
      });
  };

  return (
    <>
      <AgentNavbar />
      <div className="bgagent">
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="text-start agenth1 pt-3 font4">
              <span>My Profile</span>
            </h1>

            <span className="">
              <span className="text-muted">Dashboard</span>
              <span className="text-muted">
                <ChevronRight size={12} />
              </span>
              <span className="text-muted">My Profile</span>
            </span>
          </div>

          <div className="row g-3">
            <div className="col-md-3">
              <div className="crdmain">
                <div className="">
                  <Link to="/my-profile">
                    <div className="menu1 activetab mb-1"><User size={16}/>{" "}My Profile</div>
                  </Link>
                  <Link to="/change-password">
                    <div className="menu1 mb-1"><Key size={16}/>{" "}Change Password</div>
                  </Link>
                  <Link>
                    <div className="menu1 mb-1"><LogOut size={16}/>{" "}Logout</div>
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-md-9">
              <div className="crdmain p-3">
                <form className="text-start" onSubmit={handleSubmit}>
                  <div className="row g-2 mt-4 mb-4">
                    <div className="col-md-12">
                      <label className="text-dark mb-1 labelset2 font3">Name</label>
                      <input
                        type="text"
                        className="input1"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        placeholder="Enter Name Here.."
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="text-dark mb-1 labelset2 font3">Email Address</label>
                      <input
                        type="text"
                        className="input1"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder="Enter Email Address Here.."
                      />
                    </div>

                    <div className="col-md-6">
                      <label className="text-dark mb-1 labelset2 font3">Phone Number</label>
                      <input
                        type="text"
                        className="input1"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        placeholder="Enter Phone Number Here.."
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="text-dark mb-1 labelset2 font3">City</label>
                      <input
                        type="text"
                        className="input1"
                        name="city"
                        value={formData.city}
                        onChange={handleInputChange}
                        placeholder="Enter City Here.."
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="text-dark mb-1 labelset2 font3">State</label>
                      <input
                        type="text"
                        className="input1"
                        name="state"
                        value={formData.state}
                        onChange={handleInputChange}
                        placeholder="Enter State Here.."
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="text-dark mb-1 labelset2 font3">Country</label>
                      <input
                        type="text"
                        className="input1"
                        name="country"
                        value={formData.country}
                        onChange={handleInputChange}
                        placeholder="Enter Country Here.."
                      />
                    </div>

                    <div className="col-md-4">
                      <label className="text-dark mb-1 labelset2 font3">Pincode</label>
                      <input
                        type="text"
                        className="input1"
                        name="pincode"
                        value={formData.pincode}
                        onChange={handleInputChange}
                        placeholder="Enter Pincode Here.."
                      />
                    </div>
                  </div>

                  <div className="mb-4 text-end">
                    <button type="submit" className="submit-btn mt-3">Update</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default AgentAccount;
